import { ICourseVM } from "@/shared/model/course-vm.model";
import axios from "axios";

const baseApiUrl = "api/elearning";

export default class ElearningService {
  public updateCourse(entity: ICourseVM): Promise<ICourseVM> {
    return new Promise<ICourseVM>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-course`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findByUser(): Promise<ICourseVM> {
    return new Promise<ICourseVM>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/find-course-by-user`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findOrCreateCourse(): Promise<ICourseVM> {
    return new Promise<ICourseVM>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/find-or-create-course`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public resetSelfAssessment(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/reset-sa`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findPDF(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/download-certificate`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findEvalPDF(entity: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/download-evaluation`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
